<template>
  <v-list>
    <v-list-item class="px-6">
      <v-list-item-content>
        <PublishSwitch />
      </v-list-item-content>
    </v-list-item>
  </v-list>
</template>

<script>
import PublishSwitch from '@/components/PublishSwitch';

export default {
  name: 'ConfigShare',
  components: {
    PublishSwitch,
  },
};
</script>
